import React from 'react';
import Fieldset from '@/components/form/Fieldset/Fieldset';
import FieldGroup from '@/components/form/FieldGroup/FieldGroup';
import Label from '@/components/form/Label/Label';
import { useFormContext } from 'react-hook-form';
import TextField from '@/components/form/TextField/TextField';
import InputTelControlled from '@/components/form/InputTel/InputTelControlled';
import Checkbox from '@/components/form/Checkbox/Checkbox';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';

export interface FormContactDataProps {}

const FormContactData = ({ ...props }: FormContactDataProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormCreateJourneyDataType>();

  return (
    <Fieldset size="lg" align="center">
      <legend>Seus dados de contato</legend>
      {/*<Banner show={Object.keys(errors).length > 0} appearance="error" size="large">*/}
      {/*  <Text align="center" weight="bold">*/}
      {/*    Por favor, corrigir o(s) erro(s) abaixo:*/}
      {/*  </Text>*/}
      {/*</Banner>*/}
      <FieldGroup>
        <Label htmlFor="name">Nome completo</Label>
        <TextField id="name" error={errors.name?.message} {...register('name')} />
      </FieldGroup>
      <FieldGroup>
        <Label htmlFor="email">Email</Label>
        <TextField id="email" error={errors.email?.message} {...register('email')} />
      </FieldGroup>
      <InputTelControlled label="(Cod. Área) + Telefone" name="phone" error={errors.phone?.message} />
      <Checkbox label="Gostaria de receber ofertas exclusivas por email?" {...register('subscribeNews')} />
    </Fieldset>
  );
};

export default FormContactData;
